import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'

const ErrorPage: FC = () => {
  const router = useNavigate()
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-6 text-center bg-base-100">
      <div className="flex flex-col items-center gap-2">
        <span className="text-6xl">⚠️</span>
        <h1 className="text-4xl font-bold text-error">Oops! Algo salió mal</h1>
      </div>
      <p className="text-lg text-gray-500">
        Intenta recargar la página o contacta a soporte.
      </p>
      <button className="btn btn-error btn-wide text-white" onClick={() => {
        router('/')
      }}>
        Ir a inicio
      </button>
    </div>
  )
}

export default ErrorPage
